import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Column } from 'src/app/role/super-admin/components/catalog-management/product-import-outlet/components/import-jobs-list/import-jobs-list.component';

@Component({
    selector: 'app-manage-columns-dialog',
    templateUrl: './manage-columns-dialog.component.html',
    styleUrls: ['./manage-columns-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageColumnsDialogComponent implements OnInit {
  displayAvailableColumns: Column[];
  displaySelectedColumns: Column[];
  selectedColumn: any = null;
  avialableColumn: any = null;
  moveForward: boolean = true;
  moveBack: boolean = false;
  constructor(private dialogRef: MatDialogRef<ManageColumnsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.displayAvailableColumns = [...data.displayAvailableColumns];
    this.displaySelectedColumns = [...data.displaySelectedColumns];
  }

  ngOnInit() {
    // Intentionally left blank for future initialization logic
  }

  arrowClick(column: Column): void {
    if (!column) return;
    this.moveForward = true;
    this.moveBack = false;
    this.selectedColumn = column;
  }

  availableArrowClick(column: Column): void {
    if (column.name === 'select' || column.name === 'id' || column.name === 'product_title') return;
    this.moveForward = false;
    this.moveBack = true;
    this.selectedColumn = column;
  }


  addSelectedColumns(): void {
    if (this.selectedColumn) {
      if (this.displayAvailableColumns.includes(this.selectedColumn)) {
        this.displaySelectedColumns.push(this.selectedColumn);
        this.displayAvailableColumns = this.displayAvailableColumns.filter(col => col !== this.selectedColumn);
      } else if (this.displaySelectedColumns.includes(this.selectedColumn)) {
        this.displayAvailableColumns.push(this.selectedColumn);
        this.displaySelectedColumns = this.displaySelectedColumns.filter(col => col !== this.selectedColumn);
      }
      this.resetSelection();
    }
  }

  resetSelection(): void {
    this.selectedColumn = null;
  }

  updateDisplayedColumns() {
    const updatedColumns = {
      updatedAvailableColumns: this.displayAvailableColumns,
      updatedSelectedColumns: this.displaySelectedColumns
    }
    this.dialogRef.close(updatedColumns);
  }

  cancelManageColumns() {
    this.dialogRef.close();
  }

}
